import React from 'react';
import {BackgroundImageProps} from 'app/utilities/ImageProps';

type ContactUsItemProps = {href: string; title: string; image: BackgroundImageProps};

const ContactUsItem = ({href, image, title}: ContactUsItemProps) => (
  <a href={href} target='_blank' className='ContactUsItem'>
    <div className='ContactUsItem__image' {...image} />
    <span className='ContactUsItem__title'>{title}</span>
    <span className='ContactUsItem__button'>&#187;</span>
  </a>
);

export default ContactUsItem;
